import { usePermissionsContext } from 'contexts/PermissionsContext';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PageRedirect() {
  const { user } = usePermissionsContext();
  const navigate = useNavigate();

  useEffect(() => {
    switch(user?.role) {
      case 'admin': 
        navigate('/analytics', { replace: true });
        break;
      case 'partner': 
        navigate('/analytics', { replace: true });
        break;
      case 'analyst':
        navigate('/notas-de-agenda', { replace: true });
        break;
    }
  }, [user]);

  return null;
}
